import { ErrorModal } from "@dexteel/mesf-core";
import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { getDistinctProductCodes } from "../../pages/reports/length/repositories/lengthReportRepository";

type Props = {
	label: string;
	value: number | null;
	onChange?: (value: number | null) => void;
};

const useProductCodes = (onError?: (error: Error) => void) => {
	return useQuery<number[], Error>({
		queryKey: ["distinctProductCodes"],
		queryFn: () => getDistinctProductCodes(),
		onError: onError,
	});
};

export const ProductCodeSelector = ({
	label,
	value,
	onChange = () => {},
}: Props) => {
	const [error, setError] = useState("");

	const { data: productCodes, isLoading } = useProductCodes((error) =>
		setError(error.message),
	);

	const selectedValue = productCodes?.find((code) => code === value) ?? null;

	return (
		<>
			<Autocomplete
				id="product-code-selector"
				fullWidth
				clearOnEscape
				options={productCodes || []}
				getOptionLabel={(option) => String(option)}
				renderInput={(params) => (
					<TextField
						{...params}
						label={label}
						size="small"
						fullWidth
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<>
									{isLoading ? (
										<CircularProgress color="inherit" size={20} />
									) : (
										params.InputProps.endAdornment
									)}
								</>
							),
						}}
					/>
				)}
				value={selectedValue}
				onChange={(_event, newValue) => {
					onChange(newValue);
				}}
			/>
			<ErrorModal
				error={error}
				onHide={() => setError("")}
				title="Error loading product codes"
			/>
		</>
	);
};
